import { render } from "./premiumResource.vue?vue&type=template&id=00430784&scoped=true"
import script from "./premiumResource.vue?vue&type=script&lang=js"
export * from "./premiumResource.vue?vue&type=script&lang=js"

import "./premiumResource.vue?vue&type=style&index=0&id=00430784&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00430784"]])

export default __exports__